export default __webpack_public_path__ + "pdf/VIZBI_Sponsorship-Brochure_virtual.d46ca14.pdf";